import { useQuery } from '@apollo/client';

import { ModulePage } from '~/components/ModulePage/ModulePage';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ModuleSlotId, useRiskDetail } from '~/modules';

import { RiskDetailHeader } from './components/RiskDetailHeader/RiskDetailHeader';
import { RISK_DETAIL_QUERY } from './RiskDetail.gql';
import { modulesConfig } from './RiskDetail.modules';

export const RiskDetail = () => {
  const { id } = useRiskDetail();

  const { data } = useQuery(RISK_DETAIL_QUERY, { variables: { id } });

  return (
    <ModulePage
      header={<RiskDetailHeader name={data?.cataclysm.risk.name ?? ''} />}
      modules={<ModuleSlot id={ModuleSlotId.MAIN} modules={modulesConfig[ModuleSlotId.MAIN]} />}
    ></ModulePage>
  );
};
